export default __webpack_public_path__ + "media/flags/kn-48e20394.svg";